import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import './SimpleSlider.scss';

import a from '../../assets/carousel/a.jpg';
import b from '../../assets/carousel/b.jpg';
import c from '../../assets/carousel/c.jpg';
import d from '../../assets/carousel/d.jpg';
import e from '../../assets/carousel/e.jpg';
import f from '../../assets/carousel/f.jpg';
import g from '../../assets/carousel/g.jpg';
import h from '../../assets/carousel/h.jpg';
import i from '../../assets/carousel/i.jpg';


class SimpleSlider extends React.Component {
    render() {
        const settings = {
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            cssEase: "linear",
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        };

        return (
            <div className='slider'>
                <Slider {...settings}>
                    <div>
                        <img src={a} alt='BASE Robotics Club' />
                    </div>
                    <div>
                        <img src={b} alt='BASE Robotics Club' />
                    </div>
                    <div>
                        <img src={c} alt='BASE Robotics Club' />
                    </div>
                    <div>
                        <img src={d} alt='BASE Robotics Club' />
                    </div>
                    <div>
                        <img src={e} alt='BASE Robotics Club' />
                    </div>
                    <div>
                        <img src={f} alt='BASE Robotics Club' />
                    </div>
                    <div>
                        <img src={g} alt='BASE Robotics Club' />
                    </div>
                    <div>
                        <img src={h} alt='BASE Robotics Club' />
                    </div>
                    <div>
                        <img src={i} alt='BASE Robotics Club' />
                    </div>
                </Slider>
            </div>
        );
    }
}

export default SimpleSlider;